import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const Reports = () => {
    return (
        <Box sx={{ py: 5 }}>
            <Container>
                <Typography variant="h4" gutterBottom>
                    Reports Page
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    This page is currently under construction. The Reports functionality will be available soon.
                </Typography>
            </Container>
        </Box>
    );
};

export default Reports;
